import clsx from 'clsx';
import React from 'react';
import styled from 'styled-components';
import colors, { ColorPath } from '../../constants/colors';

const titleStyles = `
&.title_h1 {
  font-size: 36px;
}
&.title_h2 {
  font-size: 32px;
}
&.title_h3 {
  font-size: 28px;
}
&.title_h4 {
  font-size: 24px;
}
&.title_h5 {
  font-size: 24px;
}
&.title_h6 {
  font-size: 20px;
  line-height: 30px;
}
&.title_h7 {
  font-size: 20px;
  line-height: 30px;
}
&.title_h8 {
  font-size: 18px;
}
&.title_h9 {
  font-size: 18px;
  line-height: 30px;
}
&.content_1 {
  font-size: 16px;
  line-height: 24px;
}
&.content_2 {
  font-size: 16px;
  line-height: 24px;
}
&.content_3 {
  font-size: 14px;
}
&.content_3_light {
  font-family: Poppins;
  font-size: 14px;
  font-weight: 300;
}
&.body_1 {
  font-size: 14px;
}
&.caption_1 {
  font-size: 13px;
  line-height: 19.5px;
}
&.caption_2 {
  font-size: 13px;
  line-height: 19.5px;
}
&.caption_3 {
  font-size: 12px;
}
&.caption_4 {
  font-size: 10px;
}
`;

const weightStyles = `
&.regular {
  font-weight: 400;
}
&.medium {
  font-weight: 500;
}
&.semibold {
  font-weight: 600;
}
&.bold {
  font-weight: 700;
}
`;

const alignStyles = `
&.text_center {
  text-align: center;
}
&.text_left {
  text-align: left;
}
&.text_right {
  text-align: right;
}
`;

const caplockStyles = `
  &.caplock {
    text-transform: uppercase;
  }
`;

const cursorStyles = `
  &.link {
    cursor: pointer;
    &:hover {
      color: pointer;
      text-decoration-line: underline;
      text-decoration-style: solid;
      text-decoration-skip-ink: none;
      text-decoration-thickness: auto;
      text-underline-offset: auto;
      text-underline-position: from-font;
    }
  }
`;

const colorStyles = `
    &.color_neutral_text_1 {
      color: ${colors.neutral.text[1]};
    }
    &.color_neutral_text_2 {
      color: ${colors.neutral.text[2]};
    }
    &.color_neutral_text_3 {
      color: ${colors.neutral.text[3]};
    }
    &.color_neutral_text_4 {
      color: ${colors.neutral.text[4]};
    }
    &.color_neutral_text_5 {
      color: ${colors.neutral.text[5]};
    }
    &.color_neutral_text_6 {
      color: ${colors.neutral.text[6]};
    }
    &.color_primary_1 {
      color: ${colors.primary[1]};
    }
    &.color_primary_2 {
      color: ${colors.primary[2]};
    }
    &.color_primary_3 {
      color: ${colors.primary[3]};
    }
    &.color_primary_4 {
      color: ${colors.primary[4]};
    }
    &.color_primary_5 {
      color: ${colors.primary[5]};
    }
    &.color_primary_6 {
      color: ${colors.primary[6]};
    }
    &.color_secondary_1 {
      color: ${colors.secondary[1]};
    }
    &.color_secondary_2 {
      color: ${colors.secondary[2]};
    }
    &.color_secondary_3 {
      color: ${colors.secondary[3]};
    }
    &.color_secondary_4 {
      color: ${colors.secondary[4]};
    }
    &.color_secondary_5 {
      color: ${colors.secondary[5]};
    }
    &.color_secondary_6 {
      color: ${colors.secondary[6]};
    }
    &.color_purple_1 {
      color: ${colors.purple[1]};
    }
    &.color_purple_2 {
      color: ${colors.purple[2]};
    }
    &.color_purple_3 {
      color: ${colors.purple[3]};
    }
    &.color_purple_4 {
      color: ${colors.purple[4]};
    }
    &.color_other_1 {
      color: ${colors.other[1]};
    }
    &.color_other_2 {
      color: ${colors.other[2]};
    }
    &.color_other_3 {
      color: ${colors.other[3]};
    }
    &.color_orange_1 {
      color: ${colors.orange[1]};
    }
    &.color_orange_2 {
      color: ${colors.orange[2]};
    }
    &.color_orange_3 {
      color: ${colors.orange[3]};
    }
    &.color_orange_5 {
      color: ${colors.orange[5]};
    }
    &.color_orange_6 {
      color: ${colors.orange[6]};
    }
    &.color_yellow_1 {
      color: ${colors.yellow[1]};
    }
    &.color_yellow_2 {
      color: ${colors.yellow[2]};
    }
    &.color_yellow_3 {
      color: ${colors.yellow[3]};
    }
    &.color_yellow_4 {
      color: ${colors.yellow[4]};
    }
    &.color_yellow_5 {
      color: ${colors.yellow[5]};
    }
  `;

const ellipsisStyles = `
&.ellipsis {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
}
`;

const lineClampStyles = `
  &.line-clamp-1 {
    -webkit-line-clamp: 1;
  }
  &.line-clamp-2 {
    -webkit-line-clamp: 2;
  }
  &.line-clamp-3 {
    -webkit-line-clamp: 3;
  }
  &.line-clamp-4 {
    -webkit-line-clamp: 4;
  }
  &.line-clamp-5 {
    -webkit-line-clamp: 5;
  }
  &.line-clamp-6 {
    -webkit-line-clamp: 6;
  }
`;

const Container = styled.div`
  color: #1d2129;
  font-family: 'Poppins';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;

  ${titleStyles}
  ${weightStyles}
  ${colorStyles}
  ${alignStyles}
  ${cursorStyles}
  ${caplockStyles}
  ${ellipsisStyles}
  ${lineClampStyles}
`;

type AlignProps = {
  center?: boolean;
  left?: boolean;
  right?: boolean;
};

type VariantLevelProps = {
  /** Title variants */
  title_h1?: boolean;
  title_h2?: boolean;
  title_h3?: boolean;
  title_h4?: boolean;
  title_h5?: boolean;
  title_h6?: boolean;
  title_h7?: boolean;
  title_h8?: boolean;
  title_h9?: boolean;
  /** Content variants */
  content_1?: boolean;
  content_2?: boolean;
  content_3?: boolean;
  /** Body variants */
  body_1?: boolean;
  /** Caption variants */
  caption_1?: boolean;
  caption_2?: boolean;
  caption_3?: boolean;
  caption_4?: boolean;
};

type WeightProps = {
  /** Font weight */
  regular?: boolean;
  medium?: boolean;
  semibold?: boolean;
  bold?: boolean;
};

type ModifierProps = {
  caplock?: boolean;
};

type CursorProps = {
  link?: boolean;
};

type ColorProps = {
  color?: ColorPath;
};

type EllipsisProps = {
  ellipsis?: boolean;
};

type LineClampProps = {
  lineClamp?: number;
};

export type TextProps = React.HTMLAttributes<HTMLDivElement> &
  VariantLevelProps &
  WeightProps &
  ModifierProps &
  AlignProps &
  CursorProps &
  ColorProps &
  EllipsisProps &
  LineClampProps;

const Text = ({
  children,
  className,
  style,
  // Variant-Level props
  title_h1,
  title_h2,
  title_h3,
  title_h4,
  title_h5,
  title_h6,
  title_h7,
  title_h8,
  title_h9,
  content_1,
  content_2,
  content_3,
  body_1,
  caption_1,
  caption_2,
  caption_3,
  caption_4,
  // Weight props
  regular,
  medium,
  semibold,
  bold,
  // Modifier props
  caplock,
  // Align props
  center,
  left,
  right,
  // Cursor props
  link,
  color,
  ellipsis,
  lineClamp,
  ...restProps
}: TextProps) => {
  // Build the class name based on the combination of props
  const buildClassName = () => {
    const classes: string[] = [];

    // Determine variant and level
    let variant = '';
    if (title_h1) {
      variant = 'title_h1';
    } else if (title_h2) {
      variant = 'title_h2';
    } else if (title_h3) {
      variant = 'title_h3';
    } else if (title_h4) {
      variant = 'title_h4';
    } else if (title_h5) {
      variant = 'title_h5';
    } else if (title_h6) {
      variant = 'title_h6';
    } else if (title_h7) {
      variant = 'title_h7';
    } else if (title_h8) {
      variant = 'title_h8';
    } else if (title_h9) {
      variant = 'title_h9';
    } else if (content_1) {
      variant = 'content_1';
    } else if (content_2) {
      variant = 'content_2';
    } else if (content_3) {
      variant = 'content_3';
    } else if (body_1) {
      variant = 'body_1';
    } else if (caption_1) {
      variant = 'caption_1';
    } else if (caption_2) {
      variant = 'caption_2';
    } else if (caption_3) {
      variant = 'caption_3';
    } else if (caption_4) {
      variant = 'caption_4';
    }

    // Determine weight
    let weight = '';
    if (regular) weight = 'regular';
    else if (medium) weight = 'medium';
    else if (semibold) weight = 'semibold';
    else if (bold) weight = 'bold';

    // Build the main style class
    if (variant) {
      classes.push(`${variant}`);
    }
    if (weight) {
      classes.push(`${weight}`);
    }
    // Add modifiers
    if (caplock) {
      classes.push('caplock');
    }
    // Add alignment classes
    if (center) classes.push('text_center');
    if (left) classes.push('text_left');
    if (right) classes.push('text_right');

    // Add color class
    if (color) classes.push(`color_${color.replace(/\./g, '_')}`);
    // Add cursor class
    if (link) classes.push('link');

    // Add ellipsis class
    if (ellipsis) classes.push('ellipsis');
    // Add line clamp class
    if (lineClamp) classes.push(`line-clamp-${lineClamp}`);
    return classes.filter(Boolean).join(' ');
  };
  return (
    <Container {...restProps} className={clsx('custom-text', buildClassName(), className)} style={style}>
      {children}
    </Container>
  );
};

export default Text;
